import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import IconClose from 'components/icons/iconClose';
const MenuButton = t0 => {
  const $ = _c(29);
  const {
    onClick,
    open
  } = t0;
  let t1;
  if ($[0] !== open) {
    t1 = classNames("cursor-pointer max-w-[16px] relative w-4 flex flex-col", {
      open
    });
    $[0] = open;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== open) {
    t2 = classNames("bg-gray h-0.5 [transition:all_.2s_ease-in]", {
      "opacity-0 scale-0": open
    });
    $[2] = open;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <span className={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== open) {
    t4 = classNames("bg-gray h-0.5 [transition:all_.2s_ease-in] mx-0 my-1", {
      "opacity-0 scale-0": open
    });
    $[6] = open;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <span className={t4} />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== open) {
    t6 = classNames("bg-gray h-0.5 [transition:all_.2s_ease-in]", {
      "opacity-0 scale-0": open
    });
    $[10] = open;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <span className={t6} />;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = !open;
  let t9;
  if ($[14] !== open || $[15] !== t8) {
    t9 = classNames("absolute left-0 top-0 [transition:all_.2s_ease-in] ml-0.5 [&_path]:fill-gray", {
      "opacity-0 scale-0": t8,
      "opacity-100 scale-100": open
    });
    $[14] = open;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <IconClose />;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t9) {
    t11 = <span className={t9}>{t10}</span>;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t1 || $[21] !== t11 || $[22] !== t3 || $[23] !== t5 || $[24] !== t7) {
    t12 = <span className={t1}>{t3}{t5}{t7}{t11}</span>;
    $[20] = t1;
    $[21] = t11;
    $[22] = t3;
    $[23] = t5;
    $[24] = t7;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== onClick || $[27] !== t12) {
    t13 = <button className="bg-transparent border-0 flex items-center justify-center h-full w-full focus-visible:rounded-[3px]" onClick={onClick} type="button">{t12}</button>;
    $[26] = onClick;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};
MenuButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  open: PropTypes.bool
};
export default MenuButton;